import React from "react"
import { AppButtonIcon } from "@components"
import { usePerformReport } from "Pages/ReportsAlerts/Reports/@hooks"
import { CircularProgress } from "@mui/material"


export default function ReportTablePerformAction({ isRunning, enabled, idReport, name }) {

	const { isLoading, setIsLoading } = usePerformReport(idReport, name)

	if (isLoading) return <CircularProgress size={17} sx={{ m: 0.2 }}/>

	return (!isRunning && !!enabled) && <AppButtonIcon icon="gears" tooltip="Perform" onClick={setIsLoading}/>
}